export const isAuthenticated = (state) => {
    if (state.auth.auth.isAuthenticated) return true;
    return false;
};
